function getAsideBanners(thumbor, ads_url, unity, segment, squareQuantity, rectangleQuantity){
  var getUrl = ads_url+"pub/?ad_type=Banner quadrado,Banner retângulo";
  if(segment){
    getUrl = getUrl+"&ad_segment="+segment;
  }
  $.ajax({
    url: getUrl,
    type: "GET",
    crossDomain: true,
    headers: {"X-Unity": unity},
    dataType: 'json',
    success: function (result) {
        banners = []
        
        result = $.grep(result, function(b) {
          return b.segment === segment
        })

        ads_square = $.grep(result, function(b) {
          return b.type === 'Banner quadrado'
        })
        ads_rectangle = $.grep(result, function(b) {
          return b.type === 'Banner retângulo'
        })
        banners.square = (squareQuantity != null) ? ads_square.slice(0, squareQuantity) : ads_square;
        banners.rectangle = (rectangleQuantity != null) ? ads_rectangle.slice(0, rectangleQuantity) : ads_rectangle;
        
        adsense = adsenseMobile(ads_url, unity, 'Banner arranha-céu grande,Banner retângulo médio,Banner responsivo,Banner retângulo fino')

        adsenses = []
        adsenses.responsivo = $.grep(adsense, function(b) {
          return b.type === 'Banner responsivo'
        })
        adsenses.fino = $.grep(adsense, function(b) {
          return b.type === 'Banner retângulo fino'
        })
        adsenses.retangulo = $.grep(adsense, function(b) {
          return b.type === 'Banner retângulo médio'
        })
        adsenses.arranha_ceu = $.grep(adsense, function(b) {
          return b.type === 'Banner arranha-céu grande'
        })
        htmlBanners = prepareHtml(thumbor, banners, adsenses)

        if (htmlBanners != undefined) {
          document.querySelector(".aside-banners").innerHTML = htmlBanners
        }

        if (document.querySelectorAll(".aside-banners script")){
          document.querySelectorAll(".aside-banners script")
          .forEach(function (element) {
            eval(element.innerHTML);
          });
        }

        // return banners
    }
  })
}

function renderMobileSquareBanners(ads_url, unity, segment, quantity){
  var getUrl = ads_url+"pub/?ad_type=Banner quadrado,Banner retângulo";
  if(segment){
    getUrl = getUrl+"&ad_segment="+segment;
  }
  $.ajax({
    url: getUrl,
    type: "GET",
    crossDomain: true,
    headers: {"X-Unity": unity},
    dataType: 'json',
    success: function (banners) {
      banners = (quantity != null) ? banners.slice(0, quantity) : banners;
      // banners = $.grep(banners, function(b) {
      //   return b.segment === segment
      // })
      if (banners && banners.length > 0) {
        document.querySelectorAll(".square-banner").forEach(function (element) {
          banners = arrayShuffle(banners);

          var divCenterPubli = document.createElement("div");
          divCenterPubli.setAttribute("class", "center-publi no-margin-bottom");

          var divAlertPubli = document.createElement("div");
          divAlertPubli.setAttribute("class", "alert-publi");

          var spanAlertPubli = document.createElement("span");
          spanAlertPubli.textContent = "Continua depois da publicidade";

          divAlertPubli.appendChild(spanAlertPubli);
          divCenterPubli.appendChild(divAlertPubli);

          var divPubli = document.createElement("div");
          divPubli.setAttribute("class", "publi small-publi");

          banners.forEach(function (banner) {
            var aBannerLink = document.createElement("a");
            aBannerLink.href = "#";
            link = window.location.origin + "/publicidade/banner/" + banner.id;

            var imgBannerResponsiveImg = document.createElement("img");
            imgBannerResponsiveImg.setAttribute("class", "responsive-img");

            if (banner.is_script) {
              var divScript = document.createElement("div");
              divScript.classList.add("banner-script");
              url_banner_script = banner.script.replace(/"/g, "'");
              divScript.innerHTML = "<div><iframe srcdoc=\"" + url_banner_script + "\" style='height: 287px'></iframe></div>";

              divPubli.appendChild(divScript);
            } else if (banner.type !== "Banner quadrado" && banner.img_mobile) {
              imgBannerResponsiveImg.setAttribute(
                "data-src",
                banner.img_mobile
              );
              imgBannerResponsiveImg.setAttribute(
                "src",
                banner.img_mobile
              );
              imgBannerResponsiveImg.setAttribute(
                "alt",
                banner.img_mobile
              );
              imgBannerResponsiveImg.setAttribute(
                "onload", "ga('send', 'event', 'Banner Retângulo', 'Visualizações', '"+banner.name+"')"
              )
              aBannerLink.setAttribute(
                'onclick', "sendBannerAnalyticsEventClick('"+link+"','Banner Retângulo','"+banner.name+"');"
              )

              aBannerLink.appendChild(imgBannerResponsiveImg);
              divPubli.appendChild(aBannerLink);
            } else {
              imgBannerResponsiveImg.setAttribute(
                "data-src",
                banner.img_desktop
              );
              imgBannerResponsiveImg.setAttribute(
                "src",
                banner.img_desktop
              );
              imgBannerResponsiveImg.setAttribute(
                "alt",
                banner.img_desktop
              );
              imgBannerResponsiveImg.setAttribute(
                "onload", "ga('send', 'event', 'Banner Quadrado', 'Visualizações', '"+banner.name+"')"
              )
              aBannerLink.setAttribute(
                'onclick', "sendBannerAnalyticsEventClick('"+link+"','Banner Quadrado','"+banner.name+"');"
              )

              aBannerLink.appendChild(imgBannerResponsiveImg);
              divPubli.appendChild(aBannerLink);
            }

            divCenterPubli.appendChild(divPubli);
          });

          var divLine = document.createElement("div");
          divLine.setAttribute("class", "line");

          divCenterPubli.appendChild(divLine);

          element.appendChild(divCenterPubli);
        });
        document
          .querySelectorAll(".banner-script script")
          .forEach(function (element) {
            eval(element.innerHTML);
            element.innerHTML = "";
          });
        $(".small-publi").not('.slick-initialized').slick({
          autoplay: true,
          autoplaySpeed: 3000,
          fade: true,
          dots: false,
          arrows: false,
          slidesToShow: 1,
          infinite: true,
          cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
          touchThreshold: 100,
        });
      } else {
        document.querySelectorAll(".square-banner").forEach(function (element) {
          var adsenseBannerContainer = document.createElement("div");
          adsenseBannerContainer.setAttribute(
            "class",
            "ad-responsive-banner-container"
          );
          element.appendChild(adsenseBannerContainer);

          adsense = adsenseMobile(ads_url, unity, 'Banner arranha-céu grande,Banner retângulo médio,Banner responsivo,Banner retângulo fino')

          banner = []
          banner.responsivo = $.grep(adsense, function(b) {
            return b.type === 'Banner responsivo'
          })
          banner.fino = $.grep(adsense, function(b) {
            return b.type === 'Banner retângulo fino'
          })
          banner.retangulo = $.grep(adsense, function(b) {
            return b.type === 'Banner retângulo médio'
          })
          banner.arranha_ceu = $.grep(adsense, function(b) {
            return b.type === 'Banner arranha-céu grande'
          })
          if (banner.responsivo) {
            document
              .querySelectorAll(".ad-responsive-banner-container")
              .forEach(function (element) {
                url_banner_script = banner.responsivo[0].script.replace(/"/g, "'");
                element.innerHTML = "<div><iframe srcdoc=\"" + url_banner_script + "\" style='height: 287px'></iframe></div>";

                element
                  .querySelectorAll("script")
                  .forEach(function (scriptElement) {
                    eval(scriptElement.innerHTML);
                  });
              });
          }
        });
      }
    }
  })
}

// function renderAsideBanners(segment, squareQuantity, rectangleQuantity) {
//   fetch(
//     "/ajax/aside?segment=" +
//       segment +
//       "&squareQuantity=" +
//       squareQuantity +
//       "&rectangleQuantity=" +
//       rectangleQuantity
//   )
//     .then(function (response) {
//       if (response.status !== 200 || !response.ok)
//         throw new Error("Unexpected response: status " + response.status);

//       return response.text();
//     })
//     .then(function (aside) {
//       if (aside) document.querySelector(".aside-banners").innerHTML = aside;
//     })
//     .then(function () {
//       if (document.querySelectorAll(".aside-banners script"))
//         document
//           .querySelectorAll(".aside-banners script")
//           .forEach(function (element) {
//             eval(element.innerHTML);
//           });
//     })
//     .catch(function (error) {
//       console.error(error);
//     });
// }

function arrayShuffle(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var randomPosition = Math.floor(Math.random() * i);
    var currentPositionItem = array[i];
    array[i] = array[randomPosition];
    array[randomPosition] = currentPositionItem;
  }

  return array;
}

function adsenseMobile(ads_api_url, unity, types) {
  var result = null;
  $.ajax({
    method: 'GET', 
    async: false,
    url: ads_api_url + 'adsenses?adsense_type=' + types,
    headers: { 
      'X-Unity': unity,
    },
    success: function(data) {
        result = data;
    }
  });
  return result;
}

// function renderSquareBanners(segment, quantity) {
//   fetch("/ajax/mobile-aside?segment=" + segment + "&quantity=" + quantity)
//     .then(function (response) {
//       if (response.status !== 200 || !response.ok)
//         throw new Error("Unexpected response: status " + response.status);

//       return response.json();
//     })
//     .then(function (banners) {
//       if (banners && banners.length > 0) {
//         document.querySelectorAll(".square-banner").forEach(function (element) {
//           banners = arrayShuffle(banners);

//           var divCenterPubli = document.createElement("div");
//           divCenterPubli.setAttribute("class", "center-publi no-margin-bottom");

//           var divAlertPubli = document.createElement("div");
//           divAlertPubli.setAttribute("class", "alert-publi");

//           var spanAlertPubli = document.createElement("span");
//           spanAlertPubli.textContent = "Continua depois da publicidade";

//           divAlertPubli.appendChild(spanAlertPubli);
//           divCenterPubli.appendChild(divAlertPubli);

//           var divPubli = document.createElement("div");
//           divPubli.setAttribute("class", "publi small-publi");

//           banners.forEach(function (banner) {
//             var aBannerLink = document.createElement("a");
//             aBannerLink.href = "#";
//             link = window.location.origin + "/publicidade/banner/" + banner.id;

//             var imgBannerResponsiveImg = document.createElement("img");
//             imgBannerResponsiveImg.setAttribute("class", "responsive-img");

//             if (banner.is_script) {
//               var divScript = document.createElement("div");
//               divScript.classList.add("banner-script");
//               divScript.innerHTML = banner.script;

//               divPubli.appendChild(divScript);
//             } else if (banner.type !== "Banner quadrado" && banner.img_mobile) {
//               imgBannerResponsiveImg.setAttribute(
//                 "data-src",
//                 banner.img_mobile
//               );
//               imgBannerResponsiveImg.setAttribute(
//                 "onload", "ga('send', 'event', 'Banner Retângulo', 'Visualizações', '"+banner.name+"')"
//               )
//               aBannerLink.setAttribute(
//                 'onclick', "sendBannerAnalyticsEventClick('"+link+"','Banner Retângulo','"+banner.name+"');"
//               )

//               aBannerLink.appendChild(imgBannerResponsiveImg);
//               divPubli.appendChild(aBannerLink);
//             } else {
//               imgBannerResponsiveImg.setAttribute(
//                 "data-src",
//                 banner.img_desktop
//               );
//               imgBannerResponsiveImg.setAttribute(
//                 "onload", "ga('send', 'event', 'Banner Quadrado', 'Visualizações', '"+banner.name+"')"
//               )
//               aBannerLink.setAttribute(
//                 'onclick', "sendBannerAnalyticsEventClick('"+link+"','Banner Quadrado','"+banner.name+"');"
//               )

//               aBannerLink.appendChild(imgBannerResponsiveImg);
//               divPubli.appendChild(aBannerLink);
//             }

//             divCenterPubli.appendChild(divPubli);
//           });

//           var divLine = document.createElement("div");
//           divLine.setAttribute("class", "line");

//           divCenterPubli.appendChild(divLine);

//           element.appendChild(divCenterPubli);
//         });
//         document
//           .querySelectorAll(".banner-script script")
//           .forEach(function (element) {
//             eval(element.innerHTML);
//             element.innerHTML = "";
//           });
//         $(".small-publi").not('.slick-initialized').slick({
//           autoplay: true,
//           autoplaySpeed: 3000,
//           fade: true,
//           dots: false,
//           arrows: false,
//           slidesToShow: 1,
//           infinite: true,
//           cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
//           touchThreshold: 100,
//         });
//       } else {
//         document.querySelectorAll(".square-banner").forEach(function (element) {
//           var adsenseBannerContainer = document.createElement("div");
//           adsenseBannerContainer.setAttribute(
//             "class",
//             "ad-responsive-banner-container"
//           );
//           element.appendChild(adsenseBannerContainer);

//           fetch("/adsenses-ajax")
//             .then(function (response) {
//               if (response.status !== 200 || !response.ok)
//                 throw new Error(
//                   "Unexpected response: status " + response.status
//                 );

//               return response.json();
//             })
//             .then(function (banner) {
//               if (banner.responsivo) {
//                 document
//                   .querySelectorAll(".ad-responsive-banner-container")
//                   .forEach(function (element) {
//                     element.innerHTML = banner.responsivo.script;

//                     element
//                       .querySelectorAll("script")
//                       .forEach(function (scriptElement) {
//                         eval(scriptElement.innerHTML);
//                       });
//                   });
//               }
//             })
//             .catch(function (error) {
//               console.error(error);
//             });
//         });
//       }
//     })
//     .then(function () {
//       myLazyLoad = new LazyLoad();
//     })
//     .catch(function (error) {
//       console.error(error);
//     });
// }


function prepareHtml(thumbor, banners, adsense){
  var counter = 0;

  var url = window.location.origin+'/banner/redirect/'
  var html = '';
  for (var i = 0; i <= 5; i++) {
    if(banners.square !== undefined && banners.square[i] !== undefined){
      html += '<div class="aside-bannerXS--item">';
      if(banners.square[i]['is_script']){
        url_banner_script = banners.square[i].script.replace(/"/g, "'");
        html += "<div><iframe srcdoc=\"" + url_banner_script + "\" style='height: 287px'></iframe></div>";
      }else{
        if(banners.square[i].link_address.length > 4){
          html += '<a href="#">';
        }
        html += '<img src="'+thumbor+banners.square[i].img_desktop+'" alt="'+thumbor+banners.square[i].img_desktop+'" class="responsive-img" onload="ga(\'send\', \'event\', \'Banner Quadrado\', \'Visualizações\', \''+banners.square[i].name+'\')"';
        if(banners.square[i].link_address.length > 4){
          html += 'onclick="sendBannerAnalyticsEventClick(\''+url+banners.square[i].id+'\', \'Banner Quadrado\', \''+banners.square[i].name+'\')"';
        }
        html += '>';
        if(banners.square[i].link_address.length > 4){
          html += '</a>';
        }
      }
      html += '</div>'
    }else{
      if(counter < 2 && adsense.retangulo !== undefined){
        html += '<div class="aside-bannerXS--item">'
        html += adsense.retangulo[0].script
        html += '</div>'
        counter ++;
      }
    }

    if(banners.rectangle !== undefined && banners.rectangle[i] !== undefined){
      html += '    <div class="aside-banner--item">';
      if(banners.rectangle[i].is_script){
        url_banner_script = banners.rectangle[i].script.replace(/"/g, "'");
        html += "<div><iframe srcdoc=\"" + url_banner_script + "\" style='height: 287px'></iframe></div>";
      }else{
        if(banners.rectangle[i].link_address.length > 4){
          html += '<a href="#">';
        }
        html += '<img src="'+thumbor+banners.rectangle[i].img_desktop+'" alt="'+thumbor+banners.rectangle[i].img_desktop+'" class="responsive-img" onload="ga(\'send\', \'event\', \'Banner Retângulo\', \'Visualizações\', \''+banners.rectangle[i].name+'\')"';
        if(banners.rectangle[i].link_address.length > 4){
          html += 'onclick="sendBannerAnalyticsEventClick(\''+url+banners.rectangle[i].id+'\', \'Banner Retângulo\', \''+banners.rectangle[i].name+'\')"';
        }
        
        html += '>';
        if(banners.rectangle[i].link_address.length > 4){
          html += '</a>';
        }
      }
      html += '</div>'
    }else{
      if(counter < 2 && adsense.arranha_ceu !== undefined){
        html += '    <div class="aside-banner--item">'
        html += adsense.arranha_ceu[0].script
        html += '</div>'
        counter ++;
      }
    }
  }

  return html
}

function refreshBanners(adsense_mobile, banner_tag) {
  banner_tag.each(function(i, obj) {
    $(obj).html(adsense_mobile[0]['script']);
  });
}